<template>
  <el-container class="back">
    <el-aside class="left-bar">
      <div class="row sub-logo">
        <img src="/agent-logo.svg" style="width: 30px; height: 30px"/>
        <span style="margin-left:5px">AgentHub</span></div>
      <div v-for="(workflow, index) in workflows" :key="index" class="info-box">{{workflow}}</div>
    </el-aside>
    <el-container>
    </el-container>
  </el-container>
</template>

<script setup>
import {ref} from "vue";
const workflows = ref([
  "prompt1",
  "prompt2",
]);
</script>

<style scoped>


.box{
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);

}

.left-bar{
  height:100%;
  padding-left: 15px;
  padding-right:15px;
  display: flex;
  background-color:white;
  box-sizing: border-box;
  width: max-content;
  flex-direction: column;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
}



</style>